<h2 mat-dialog-title id="Wizualizacja" [translation]="TranslationEnum.TranslationForm">
  {{'Wizualizacja' |translate}}
</h2>
<mat-dialog-content class="pt-3 pb-3 pr-4 pl-4">
  <variantic-player #variantic background-transparent component-id="36" disable-layout = "true">
  </variantic-player>
</mat-dialog-content>
